import { App } from '@capacitor/app';
import { Toast } from '@capacitor/toast';
import { StatusBar, Style } from '@capacitor/status-bar';
import { useEffect } from 'react';
import { Device } from '@capacitor/device';
import { SplashScreen } from '@capacitor/splash-screen';
import { useQuery } from '@tanstack/react-query';
import loadable from '@loadable/component';

const AndroidInit = loadable(() => import('./components/AndroidInit'), {
  resolveComponent: (components) => components.AndroidInit,
});

export function NativeAppInit() {
  const {
    data: deviceInfo,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['device-info'],
    queryFn: async () => {
      return await Device.getInfo();
    },
    staleTime: Infinity,
    retry: false,
  });

  useEffect(() => {
    SplashScreen.hide();
  }, []);

  useEffect(() => {
    StatusBar.setStyle({
      style: Style.Dark,
    });
  }, []);

  useEffect(() => {
    let lastTimeBackPress = 0;
    const setupBackButton = () => {
      return App.addListener('backButton', async ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
          return;
        }

        const currentTime = new Date().getTime();

        if (currentTime - lastTimeBackPress < 2000) {
          App.exitApp();
        } else {
          lastTimeBackPress = currentTime;
          try {
            await Toast.show({
              text: 'Press back again to exit',
              duration: 'short',
              position: 'bottom',
            });
          } catch (toastError) {
            console.error('Failed to show toast:', toastError);
          }
        }
      });
    };

    const listenerPromise = setupBackButton();

    return () => {
      listenerPromise.then((listener) => listener.remove());
    };
  }, []);

  if (isLoading || error) {
    return null;
  }

  return deviceInfo?.platform === 'android' ? <AndroidInit /> : null;
}
